import { ProductCard } from "@aurelia/ui";
import { useRecentlyViewed } from "../../lib/useRecentlyViewed";

// Renders from localStorage snapshot data only, so no live stock/wishlist
// state is shown here — that avoids displaying a stale badge for a product
// that may have sold out or changed price since it was last viewed.
export function RecentlyViewedSection({ excludeSlug }: { excludeSlug?: string }) {
  const entries = useRecentlyViewed(excludeSlug);

  if (entries.length === 0) return null;

  return (
    <section className="mt-24 max-w-6xl mx-auto">
      <h2 className="text-display-sm mb-8">Recently viewed</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {entries.slice(0, 4).map((entry) => (
          <ProductCard
            key={entry.slug}
            slug={entry.slug}
            name={entry.name}
            imageUrl={entry.imageUrl}
            basePrice={entry.basePrice}
            compareAtPrice={entry.compareAtPrice}
          />
        ))}
      </div>
    </section>
  );
}
